import type { MisconceptionDefinition } from '../types'

export const lengteMisconceptions: MisconceptionDefinition[] = [
  {
    id: 'met.eenheid-factor-10',
    label: 'Factor 10 fout',
    module: 'Metriek',
    description:
      'Leerling vermenigvuldigt of deelt met de verkeerde factor van 10 bij eenheidsomrekening.',
    typicalFamilies: ['MET-LEN-OMREKEN', 'MET-GEW-OMREKEN', 'MET-INH-OMREKEN'],
  },
  {
    id: 'met.schaal-eenheid-omrekenen',
    label: 'Eenheid vergeten om te rekenen bij schaal',
    module: 'Metriek',
    description:
      'Leerling vergeet cm naar m of km om te rekenen na de schaalberekening.',
    typicalFamilies: ['MET-SCHAAL-BASIS', 'MET-SCHAAL-LENGTE'],
  },
  {
    id: 'met.schaal-opp-niet-gekwadrateerd',
    label: 'Schaalfactor niet gekwadrateerd bij oppervlakte',
    module: 'Metriek',
    description:
      'Leerling vermenigvuldigt oppervlakte met de schaalfactor i.p.v. met het kwadraat ervan. Bijv. ×100 i.p.v. ×10.000 bij schaal 1:100.',
    typicalFamilies: ['MET-SCHAAL-OPP'],
  },
  {
    id: 'met.symmetrie-lijnen-aantal',
    label: 'Aantal symmetrielijnen verward',
    module: 'Metriek',
    description:
      'Leerling verwart het aantal symmetrielijnen van verschillende figuren (bijv. vierkant=4, rechthoek=2, gelijkzijdige driehoek=3).',
    typicalFamilies: ['MET-SYMMETRIE'],
  },
  {
    id: 'met.symmetrie-spiegelas-fout',
    label: 'Spiegelas verward',
    module: 'Metriek',
    description:
      'Leerling spiegelt over de verkeerde as (bijv. horizontaal i.p.v. verticaal) of verwart x- en y-coördinaat bij spiegeling.',
    typicalFamilies: ['MET-SYMMETRIE'],
  },
  {
    id: 'met.schaal-richting-omgedraaid',
    label: 'Schaal-richting omgedraaid',
    module: 'Metriek',
    description:
      'Leerling vermenigvuldigt waar gedeeld moet worden (of andersom) bij schaalberekening (werkelijk ↔ kaart richting verwisseld).',
    typicalFamilies: [
      'MET-SCHAAL-BASIS',
      'MET-SCHAAL-LENGTE',
      'MET-SCHAAL-OPP',
    ],
  },
  {
    id: 'met.komma-vermenigvuldigen-rekenfout',
    label: 'Rekenfout in komma-vermenigvuldiging',
    module: 'Metriek',
    description:
      'Leerling maakt een rekenfout bij vermenigvuldigen met kommagetallen in een metriek-context (bijv. parallellogram met decimale hoogte).',
    typicalFamilies: [
      'MET-OPP-PARALLELLOGRAM',
      'MET-OPP-DRIEHOEK',
      'MET-OPP-RECHT',
    ],
  },
  {
    id: 'met.meting-streepje-fout',
    label: 'Eén streepje verkeerd afgelezen',
    module: 'Metriek',
    description:
      'Leerling leest één streepje te veel of te weinig af op een liniaal / maatbeker / schaal.',
    typicalFamilies: ['MET-LEN-METEN', 'MET-INH-CITER', 'MET-INH-LITER'],
  },
  {
    id: 'met.meting-verkeerde-eenheid',
    label: 'Verkeerde eenheid afgelezen',
    module: 'Metriek',
    description:
      'Leerling leest in de verkeerde eenheid af (bijv. cm i.p.v. mm) bij een meetinstrument.',
    typicalFamilies: ['MET-LEN-METEN', 'MET-LEN-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-cijfers-achterelkaar',
    label: 'Tijd-cijfers achter elkaar geplakt',
    module: 'Metriek',
    description:
      'Leerling plakt minuten- en secondencijfers achter elkaar als één getal (bijv. 1 min 30 sec → 130).',
    typicalFamilies: ['MET-TIJD-METEN', 'MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-minuut-niet-60',
    label: 'Minuut niet als 60 seconden gerekend',
    module: 'Metriek',
    description:
      'Leerling rekent een minuut als 100 seconden (decimaal) i.p.v. 60 seconden.',
    typicalFamilies: ['MET-TIJD-METEN'],
  },
  {
    id: 'met.tijd-dubbele-minuut',
    label: 'Minuut dubbel geteld',
    module: 'Metriek',
    description:
      'Leerling telt de minuut zowel als losse minuten als opgeteld bij de secondenwaarde.',
    typicalFamilies: ['MET-TIJD-METEN'],
  },
  {
    id: 'met.tijd-honderdsten-min-tienden',
    label: 'Honderdsten verward met tienden van een seconde',
    module: 'Metriek',
    description:
      'Leerling leest honderdsten als tienden (of omgekeerd) bij nauwkeurige tijdmeting.',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-honderdsten-eigen-ipv-verschil',
    label: 'Honderdsten van één tijd i.p.v. tijdverschil',
    module: 'Metriek',
    description:
      'Leerling geeft de honderdsten-component van één van de twee tijden als antwoord i.p.v. het verschil tussen de twee tijden uit te rekenen.',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-honderdsten-als-tienden',
    label: 'Honderdsten gelezen als tienden',
    module: 'Metriek',
    description:
      'Leerling leest 0,05 sec als 0,5 sec (honderdsten-positie verwisseld met tienden).',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-heel-getal-als-tienden',
    label: 'Heel getal achter komma als tienden',
    module: 'Metriek',
    description:
      'Leerling leest een tweecijferig getal achter de komma als tienden (bijv. 12 honderdsten als 0,12 i.p.v. 0,12).',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.lengte-komma-verschoven',
    label: 'Komma één positie verschoven (lengte)',
    module: 'Metriek',
    description:
      'Leerling verschuift de komma één positie te ver / te weinig bij nauwkeurige lengtemeting.',
    typicalFamilies: ['MET-LEN-NAUWKEURIG'],
  },
  {
    id: 'met.lengte-mm-cm-relatie-fout',
    label: 'mm/cm-relatie fout (×10 vergeten of verkeerd toegepast)',
    module: 'Metriek',
    description:
      'Leerling past de relatie 1 cm = 10 mm verkeerd toe bij conversie tussen mm en cm.',
    typicalFamilies: ['MET-LEN-NAUWKEURIG', 'MET-LEN-METEN'],
  },
  {
    id: 'met.lengte-cm-naar-m-fout',
    label: 'cm naar m conversie fout in context',
    module: 'Metriek',
    description:
      'Leerling vergeet of past de cm→m conversie (÷100) verkeerd toe in een lengte-context-opgave.',
    typicalFamilies: ['MET-LEN-CONTEXT'],
  },
  {
    id: 'met.lengte-optellen-ipv-aftrekken',
    label: 'Lengte opgeteld i.p.v. afgetrokken',
    module: 'Metriek',
    description:
      'Leerling telt lengtes op waar afgetrokken moet worden (bijv. resterend lint na knippen).',
    typicalFamilies: ['MET-LEN-CONTEXT'],
  },
  {
    id: 'met.lengte-optellen-ipv-vermenigvuldigen',
    label: 'Lengte opgeteld i.p.v. vermenigvuldigd',
    module: 'Metriek',
    description:
      'Leerling telt op waar vermenigvuldigd moet worden (bijv. n × stuklengte voor totale lengte van n stukken).',
    typicalFamilies: ['MET-LEN-CONTEXT'],
  },
  {
    id: 'met.lengte-deur-onderschat',
    label: 'Lengte van een deur onderschat',
    module: 'Metriek',
    description:
      'Leerling kiest een te kleine schatting (bijv. 1 m) voor de hoogte van een standaard deur (~2 m).',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-deur-5m-niet-herkend',
    label: 'Deur als 5 m geschat',
    module: 'Metriek',
    description:
      'Leerling kiest een onrealistisch hoge schatting (5 m) voor de hoogte van een deur.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-deur-overschat',
    label: 'Lengte van een deur overschat',
    module: 'Metriek',
    description:
      'Leerling kiest een te grote schatting voor de hoogte van een standaard deur.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-km-schoolplein-overschat',
    label: 'Schoolplein als km i.p.v. m geschat',
    module: 'Metriek',
    description:
      'Leerling schat de lengte van een schoolplein in kilometers terwijl meters past.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-km-klaslokaal-overschat',
    label: 'Klaslokaal als km i.p.v. m geschat',
    module: 'Metriek',
    description:
      'Leerling schat de afmetingen van een klaslokaal in kilometers terwijl meters past.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-km-zwembad-overschat',
    label: 'Zwembad als km i.p.v. m geschat',
    module: 'Metriek',
    description:
      'Leerling schat de lengte van een zwembad in kilometers terwijl meters past.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-km-x10000',
    label: 'Denkt dat 1 km = 10.000 m',
    module: 'Metriek',
    description:
      'Leerling rekent km naar m met factor 10.000 in plaats van 1.000.',
    typicalFamilies: ['MET-LEN-CONTEXT', 'MET-LEN-OMREKEN'],
  },
  {
    id: 'met.lengte-km-x100',
    label: 'Denkt dat 1 km = 100 m',
    module: 'Metriek',
    description:
      'Leerling rekent km naar m met factor 100 in plaats van 1.000.',
    typicalFamilies: ['MET-LEN-CONTEXT', 'MET-LEN-OMREKEN'],
  },
  {
    id: 'met.lengte-km-x10',
    label: 'Denkt dat 1 km = 10 m',
    module: 'Metriek',
    description: 'Leerling rekent km naar m met factor 10 in plaats van 1.000.',
    typicalFamilies: ['MET-LEN-CONTEXT', 'MET-LEN-OMREKEN'],
  },
  {
    id: 'met.lengte-m-cm-x1000',
    label: 'Denkt dat 1 m = 1.000 cm',
    module: 'Metriek',
    description:
      'Leerling rekent m naar cm met factor 1.000 in plaats van 100.',
    typicalFamilies: ['MET-LEN-CONTEXT', 'MET-LEN-OMREKEN'],
  },
  {
    id: 'met.lengte-m-cm-x10',
    label: 'Denkt dat 1 m = 10 cm',
    module: 'Metriek',
    description: 'Leerling rekent m naar cm met factor 10 in plaats van 100.',
    typicalFamilies: ['MET-LEN-CONTEXT', 'MET-LEN-OMREKEN'],
  },
  {
    id: 'met.lengte-cijfers-aanplakken',
    label: 'Cijfers achter elkaar geplakt bij gemengde eenheden',
    module: 'Metriek',
    description:
      'Leerling plakt het cm-getal direct achter het m-getal i.p.v. de eenheden om te rekenen (bijv. 2 m 30 cm → 230 als losse cijfers).',
    typicalFamilies: ['MET-LEN-CONTEXT'],
  },
  {
    id: 'met.lengte-eenheid-fout',
    label: 'Antwoord in verkeerde lengte-eenheid',
    module: 'Metriek',
    description:
      'Leerling geeft het antwoord in een andere eenheid dan gevraagd (bijv. cm i.p.v. m).',
    typicalFamilies: ['MET-LEN-CONTEXT', 'MET-LEN-OMREKEN'],
  },
  {
    id: 'met.lengte-decimaal-vermenigvuldigen-fout',
    label: 'Rekenfout bij vermenigvuldigen met decimaal',
    module: 'Metriek',
    description:
      'Leerling maakt een rekenfout bij vermenigvuldigen met een kommagetal in een lengte-context (bijv. 3 × 1,5 m).',
    typicalFamilies: ['MET-LEN-CONTEXT'],
  },
  {
    id: 'met.lengte-m-naar-km-fout',
    label: 'm naar km conversie fout in context',
    module: 'Metriek',
    description:
      'Leerling deelt verkeerd door 1.000 of vergeet rondjes mee te nemen bij m→km in een context-opgave.',
    typicalFamilies: ['MET-LEN-CONTEXT'],
  },
  {
    id: 'met.meting-begin-als-lengte',
    label: 'Begingetal als lengte gelezen',
    module: 'Metriek',
    description:
      'Leerling leest het begingetal op het meetinstrument als de lengte i.p.v. het verschil te berekenen.',
    typicalFamilies: ['MET-LEN-METEN'],
  },
  {
    id: 'met.meting-eind-als-lengte',
    label: 'Eindgetal als lengte gelezen',
    module: 'Metriek',
    description:
      'Leerling leest het eindgetal op het meetinstrument als de lengte zonder het begingetal af te trekken.',
    typicalFamilies: ['MET-LEN-METEN'],
  },
  {
    id: 'met.meting-optellen-ipv-aftrekken',
    label: 'Optellen i.p.v. aftrekken bij meting',
    module: 'Metriek',
    description:
      'Leerling telt begin- en eindwaarde op i.p.v. het verschil te bepalen bij een meting.',
    typicalFamilies: ['MET-LEN-METEN'],
  },
  {
    id: 'met.lengte-gemengde-eenheid-fout',
    label: 'Fout bij gemengde lengte-eenheden',
    module: 'Metriek',
    description:
      'Leerling combineert mm- en cm-aflezingen verkeerd (bijv. losse streepjes vergeten op te tellen, of komma direct verschoven).',
    typicalFamilies: ['MET-LEN-METEN', 'MET-LEN-NAUWKEURIG'],
  },
  {
    id: 'met.lengte-komma-positie-fout',
    label: 'Komma op verkeerde plek (lengte)',
    module: 'Metriek',
    description:
      'Leerling plaatst de komma na het verkeerde cijfer bij nauwkeurige lengtenotatie.',
    typicalFamilies: ['MET-LEN-NAUWKEURIG'],
  },
  {
    id: 'met.lengte-decimaal-extra-nul',
    label: 'Extra nul in decimaal (lengte)',
    module: 'Metriek',
    description:
      'Leerling voegt een extra nul toe achter de komma (bijv. 0,07 i.p.v. 0,7).',
    typicalFamilies: ['MET-LEN-NAUWKEURIG'],
  },
  {
    id: 'met.lengte-komma-weggelaten',
    label: 'Komma weggelaten bij lengte',
    module: 'Metriek',
    description:
      'Leerling laat de komma weg en geeft het ruwe getal zonder eenheid om te rekenen.',
    typicalFamilies: ['MET-LEN-NAUWKEURIG'],
  },
  {
    id: 'met.lengte-decimaal-gesplitst',
    label: 'Decimaal apart gehouden bij vermenigvuldiging',
    module: 'Metriek',
    description:
      'Leerling vermenigvuldigt alleen het heelgetal en laat het decimale deel ongewijzigd.',
    typicalFamilies: ['MET-LEN-NAUWKEURIG'],
  },
  {
    id: 'met.nauwkeurigheid-afgerond-vs-precies',
    label: 'Afgerond getal als nauwkeurig beschouwd',
    module: 'Metriek',
    description:
      'Leerling beschouwt een afgerond getal als een nauwkeurige meting.',
    typicalFamilies: ['MET-LEN-NAUWKEURIG'],
  },
  {
    id: 'met.nauwkeurigheid-schatting-vs-meting',
    label: 'Schatting als meting beschouwd',
    module: 'Metriek',
    description:
      'Leerling beschouwt een schatting of vage omschrijving als een echte meting.',
    typicalFamilies: ['MET-LEN-NAUWKEURIG'],
  },
  {
    id: 'met.lengte-stap-te-weinig',
    label: 'Te weinig stappen op het metrieke trapje (lengte)',
    module: 'Metriek',
    description:
      'Leerling rekent met te weinig stappen bij lengte-omrekening (bijv. ×10 i.p.v. ×100).',
    typicalFamilies: ['MET-LEN-OMREKEN'],
  },
  {
    id: 'met.lengte-stap-te-veel',
    label: 'Te veel stappen op het metrieke trapje (lengte)',
    module: 'Metriek',
    description:
      'Leerling rekent met een stap te veel bij lengte-omrekening (bijv. ×1.000 i.p.v. ×100).',
    typicalFamilies: ['MET-LEN-OMREKEN'],
  },
  {
    id: 'met.lengte-richting-omgedraaid',
    label: 'Richting omgedraaid bij lengte-omrekening',
    module: 'Metriek',
    description:
      'Leerling vermenigvuldigt waar gedeeld moet worden (of omgekeerd) bij lengte-omrekening.',
    typicalFamilies: ['MET-LEN-OMREKEN'],
  },
  {
    id: 'met.lengte-eenheid-meter-default',
    label: 'Meter gekozen voor klein voorwerp',
    module: 'Metriek',
    description:
      'Leerling kiest de meter als eenheid voor een voorwerp dat in cm of mm gemeten zou worden.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-eenheid-mm-onhandig',
    label: 'Millimeter onhandig gekozen',
    module: 'Metriek',
    description:
      'Leerling kiest millimeter waar centimeter een handigere eenheid zou zijn.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-eenheid-km-absurd',
    label: 'Kilometer absurd gekozen',
    module: 'Metriek',
    description:
      'Leerling kiest kilometer als eenheid voor een klein voorwerp — orde van grootte fout.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-cm-voetbal-overschat',
    label: 'Voetbal overschat als 1 cm',
    module: 'Metriek',
    description:
      'Leerling denkt dat een voetbal ongeveer 1 cm groot is — orde van grootte fout.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-cm-tafel-overschat',
    label: 'Tafelbreedte overschat als 1 cm',
    module: 'Metriek',
    description:
      'Leerling denkt dat een tafel ongeveer 1 cm breed is — orde van grootte fout.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-cm-boek-overschat',
    label: 'Boekbreedte overschat als 1 cm',
    module: 'Metriek',
    description:
      'Leerling denkt dat een boek ongeveer 1 cm breed is — orde van grootte fout.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-volgorde-fout-niet-herkend',
    label: 'Volgorde-fout bij rangschikking niet herkend',
    module: 'Metriek',
    description:
      'Leerling herkent niet dat een lengte-rangschikking in de verkeerde volgorde staat.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-volgorde-tafel-auto',
    label: 'Tafel en auto in verkeerde volgorde',
    module: 'Metriek',
    description:
      'Leerling rangschikt een tafel en een auto naar lengte in de verkeerde volgorde.',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-volgorde-richting-fout',
    label: 'Volgorde-richting verwisseld bij lengte-rangschikking',
    module: 'Metriek',
    description:
      'Leerling rangschikt voorwerpen van lang naar kort terwijl kort naar lang gevraagd was (of omgekeerd).',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-deur-cm-schatten-fout',
    label: 'Deurhoogte buiten realistische range geschat',
    module: 'Metriek',
    description:
      'Leerling schat de hoogte van een deur in cm buiten de realistische range (~200 cm).',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.lengte-voetbalveld-schatten-fout',
    label: 'Voetbalveld-lengte buiten realistische range geschat',
    module: 'Metriek',
    description:
      'Leerling schat de lengte van een voetbalveld buiten de realistische range (~100 m).',
    typicalFamilies: ['MET-LEN-SCHATTEN'],
  },
  {
    id: 'met.tijd-seconden-vergeten',
    label: 'Losse seconden vergeten op te tellen',
    module: 'Metriek',
    description:
      'Leerling vergeet de seconden-component op te tellen bij het totaal bij een stopwatch-aflezing.',
    typicalFamilies: ['MET-TIJD-METEN'],
  },
  {
    id: 'met.tijd-rondje1-als-allemaal',
    label: 'Eerste rondje gebruikt als alle rondjes',
    module: 'Metriek',
    description:
      'Leerling denkt dat elk rondje even lang duurt als het eerste rondje.',
    typicalFamilies: ['MET-TIJD-METEN'],
  },
  {
    id: 'met.tijd-seconden-als-rondetijd',
    label: 'Alleen seconden-deel als rondetijd gelezen',
    module: 'Metriek',
    description:
      'Leerling leest alleen het seconden-deel van de stopwatch als rondetijd en negeert de minuten.',
    typicalFamilies: ['MET-TIJD-METEN'],
  },
  {
    id: 'met.tijd-totaal-als-rondetijd',
    label: 'Totaaltijd verward met rondetijd',
    module: 'Metriek',
    description:
      'Leerling geeft de totale tijd als rondetijd zonder te delen door het aantal rondjes.',
    typicalFamilies: ['MET-TIJD-METEN'],
  },
  {
    id: 'met.tijd-verschil-fout',
    label: 'Rekenfout bij tijdverschil',
    module: 'Metriek',
    description:
      'Leerling maakt een rekenfout bij het berekenen van het verschil tussen twee tijden.',
    typicalFamilies: ['MET-TIJD-METEN', 'MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-snelste-als-antwoord',
    label: 'Snelste tijd als antwoord i.p.v. verschil',
    module: 'Metriek',
    description:
      'Leerling geeft de snelste tijd als antwoord in plaats van het verschil tussen twee tijden te berekenen.',
    typicalFamilies: ['MET-TIJD-METEN'],
  },
  {
    id: 'met.tijd-langzaamste-als-antwoord',
    label: 'Langzaamste tijd als antwoord i.p.v. verschil',
    module: 'Metriek',
    description:
      'Leerling geeft de langzaamste tijd als antwoord in plaats van het verschil tussen twee tijden te berekenen.',
    typicalFamilies: ['MET-TIJD-METEN'],
  },
  {
    id: 'met.tijd-verschil-x10',
    label: 'Tijdverschil met 10 vermenigvuldigd',
    module: 'Metriek',
    description:
      'Leerling vermenigvuldigt het verschil tussen twee tijden onbedoeld met 10 (komma-shift fout).',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-honderdsten-vs-tienden',
    label: 'Honderdsten en tienden verwisseld',
    module: 'Metriek',
    description:
      'Leerling leest 0,04 sec als 0,4 sec (of omgekeerd) — verwart de positie van honderdsten en tienden.',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-tienden-als-honderdsten',
    label: 'Tienden als honderdsten gelezen',
    module: 'Metriek',
    description:
      'Leerling leest één cijfer achter de punt als honderdsten in plaats van tienden.',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-minuten-niet-gelezen',
    label: 'Minuten niet meegelezen',
    module: 'Metriek',
    description:
      'Leerling negeert de minuten-component bij een nauwkeurige stopwatch-aflezing.',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-afronden-naar-beneden',
    label: 'Tijd naar beneden afgerond',
    module: 'Metriek',
    description:
      'Leerling rondt een tijd naar beneden af terwijl de regel naar boven of normaal afronden vraagt.',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-afronden-op-tienden',
    label: 'Verkeerd niveau afgerond',
    module: 'Metriek',
    description:
      'Leerling rondt af op tienden waar honderdsten gevraagd was (of omgekeerd).',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-niet-afgerond',
    label: 'Tijd niet afgerond',
    module: 'Metriek',
    description:
      'Leerling geeft de exacte tijd terwijl er afronding op tienden of honderdsten gevraagd was.',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
  {
    id: 'met.tijd-seconden-naar-honderdsten-fout',
    label: 'Seconden naar honderdsten conversie fout',
    module: 'Metriek',
    description:
      'Leerling maakt een fout bij het omrekenen van hele seconden naar honderdsten van een seconde.',
    typicalFamilies: ['MET-TIJD-NAUWKEURIG'],
  },
]
